import React, {useEffect, useState} from "react";
import {TextField} from "@mui/material";
import {produce} from "immer";
import MenuItem from "@mui/material/MenuItem";
const ProjectDetailValidatedDropdown = ({
                                          productItem, 
                                          field, 
                                          draftQuoteDetail, 
                                          setDraftQuoteDetail, 
                                          disabled, 
                                          id, 
                                          onChange }) => 
{
    const [value, setValue] = useState(() => {
        const id =  draftQuoteDetail.productItemId ?? draftQuoteDetail.productGroupId;
        if (id) {
            return draftQuoteDetail.quoteDetailFieldValues?.find(detail =>
                detail.productItemId === productItem.id)?.fields
                .find(updatedField => updatedField.fieldId === field.id).value;
        }
        return null;
    });
    const [error, setError] = useState(false);

    useEffect(() => {
        setValue(() => {
            const id = draftQuoteDetail.productItemId ?? draftQuoteDetail.productGroupId;
            if (id) {
                return draftQuoteDetail.quoteDetailFieldValues?.find(detail =>
                    detail.productItemId === productItem.id)?.fields
                    .find(updatedField => updatedField.fieldId === field.id).value;
            }
            return null;
        });
    }, [draftQuoteDetail])
    
    const handleChange = e => {
        const newValue = e.target.value;
        const errorMessage = newValue === '' ? "Please select an option" : false;
        setValue(newValue);
        setError(errorMessage);
        onChange(!errorMessage);
        if (!errorMessage) {
            handleInputSelection(productItem.id, field.id, newValue);
        }
    };

    const handleInputSelection = (itemId, fieldId, newValue)  => {
        setDraftQuoteDetail(produce(draftQuoteDetail, draft => {
            const field = draft.quoteDetailFieldValues
                .find(detail => detail.productItemId === itemId)
                ?.fields.find(field => field.fieldId === fieldId);

            if (field) {
                field.value = newValue;
            }
        }));
    }
    
    return (
        <TextField
            id={draftQuoteDetail.id !== undefined
                ? `${draftQuoteDetail.id}-${field.id}`
                : `${draftQuoteDetail.tempId}-${field.id}`}
            disabled={disabled}
            select
            label={field.displayName}
            value={value || ''}
            key={id}
            required
            error={!!error}
            helperText={error}
            onChange={handleChange}
            sx={{
                textAlign: 'left',
                width: {xs: '250px !important', md: '300px !important'}
            }}
        >
            {field.enumOptions.map((option, i) => (
                <MenuItem key={i} value={option} sx={{ textAlign: 'left' }}>
                    {option}
                </MenuItem>
            ))}
        </TextField>
    );
};

export default ProjectDetailValidatedDropdown;